<template>
    <div class="layer mask50" v-show="visible">
        <!-- 支付对话框 -->
        <div class="payDialog w100p">
            <div class="inner" style="padding-bottom: 20px;">

                <div class="title generalPagePaddingH alignCenter">
                    <div class="inner relative">
                        <i class="icon closeIcon" v-show="currentContent == contents.pay"
                           v-on:click="close()" style="right: 0; left: auto;"></i>

                        <!-- 完善信息时显示 -->
                        <i class="icon closeIcon" v-show="currentContent == contents.fillInContactInformation"
                           v-on:click="currentContent = contents.pay" style="right: 0; left: auto;"></i>

                        <i class="icon leftAngleBracketIcon" v-show="currentContent == contents.coupon"
                           v-on:click="currentContent = contents.pay"></i>
                        <span class="bold">
                            {{currentContent ? currentContent.title : ''}}
                        </span>
                    </div>
                </div>

                <!-- 支付选项 -->
                <div class="generalPagePaddingH"
                     v-show="currentContent == contents.pay" :data-id="product ? product.id : ''">

                    <div class="alignCenter color333" style="line-height: 30px; padding: 30px 0 32px; ">
                        <span class="bold font18r">{{currencyType}}</span>
                        <span class="bold" style="font-size: 175%;">
                            {{price}}
                        </span>
                        <!-- 原价 -->
                        <span class="bold font12r textDelete" style="margin-left: 10px; color: #BDBDBD;"
                              v-if="selectedCoupon">
                            ￥{{product ? product.price : ''}}
                        </span>
                    </div>

                    <div class="productInfo bgFAFAFA roundBorder8 marginB12">
                        <div class="flexLayout">
                            <div style="width: 97px;">
                                <img class="fitTypeCover block" :src="product.image"
                                     width="97" height="58" style="border-radius: 6px;" v-if="product"/>
                            </div>
                            <div class="flexItem" style="line-heihgt: 20px;">
                                <div class="productTitle bold font14r">
                                    {{product ? product.title : 'loading...'}}
                                </div>
                                <div class="desc">{{product ? product.desc || '' : ''}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="options lightGreyBg" style="padding: 11px 8px;" v-show="enableCoupon || couponList.length">
                        <div class="optionItem coupon clearfix">
                            <div class="optionTitle inlineBlock font14r color333 marginR12">优惠券</div>
                            <!--                            <div class="optionValue inlineBlock font12r color999"-->
                            <!--                                 v-on:click="currentContent = contents.coupon">-->

                            <!--                            </div>-->
                            <div class="fr font12r color999" v-on:click="selectCoupon()">
                                <template v-if="!couponList.length">暂无优惠券可选</template>
                                <template v-if="couponList.length && !selectedCoupon">选择优惠券</template>
                                <template v-if="selectedCoupon">
                                    <span class="color999">
                                        -{{currencyType}}{{selectedCoupon.discountAmount}}
                                    </span>
                                </template>
                                <i class="icon arrowIcon relative"
                                   style="width: 12px; height: 12px; top: 2px; margin-left: 2px;"></i>
                                <!--                                <i class="icon moreContentRightAngleBracketIcon"></i>-->
                            </div>
                        </div>
                    </div>

                    <!-- 个人信息 FillInContactInformation -->
                    <div class="lightGreyBg marginT12" v-show="needFillInContactInformation">
                        <div class="paddingH8 paddingV12">
                            <div class="clearfix" style="line-height: 14px;">
                                <div class="fl font14r darkgrey">个人信息</div>
                                <div class="fr font12r" style="" @click="fillInContactInformation()">
                                    <span class="red" v-show="!submitedContactInformation">去完善信息</span>
                                    <span class="grey20 bold" v-show="submitedContactInformation">已完善信息</span>
                                    <i class="icon arrowIcon marginL8 relative" style="top: 2px"></i>
                                </div>
                            </div>
                            <div class="marginT8 grey font10r">
                                参照国家标准《个人信息标准》请完善个人信息
                            </div>
                        </div>
                    </div><!-- End 个人信息 FillInContactInformation -->

                    <!-- 支付类型选项 -->
                    <!--                    <div class="payTypeArea marginT24" style="line-height: 16px;">-->
                    <!--                        <div class="item roundBorder8 bgFAFAFA">-->
                    <!--                            <i class="icon wechatPayIcon size16 marginR8 fl"></i>-->
                    <!--                            微信支付-->
                    <!--                            <i class="icon orangeCircleCheckedIcon fr" style="width: 14px; height: 14px;"></i>-->
                    <!--                        </div>-->
                    <!--                    </div>-->


                    <!-- 选择协议 -->
                    <div class="font13r generalPagePaddingH marginT12 alignCenter">
                        <label>
                            <input class="modernCheckbox" type="checkbox"
                               style="vertical-align: middle; margin: -2px 6px 0;"
                               :checked="agreeServiceProtocol" v-model="agreeServiceProtocol"/>
                            <span style="color: hsla(219, 9%, 39%, 1)">同意</span>
                            <router-link style="color: hsla(2, 100%, 70%, 1);" :to="agreeServiceUrl">
                                《{{agreeServiceName}}》
                            </router-link>
                        </label>
                    </div>

                    <!-- Pay -->
                    <div class="payDiv alignCenter" style="padding-top: 38px; padding-bottom: 8px;">
                        <button class="block centered alignCenter payButton bold noBorder white" v-on:click="pay()"
                                :disabled="status === 'loading'" v-if="!payStatus">
                            <i class="fa fa-spinner rotate" v-if="status === 'loading'" style="width:20px; height:20px"></i>
                            立即支付<br/>
                            <span style="font-size: 56.25%; line-height: 2em">（合计：¥{{product ? product.price : ''}}）</span>
                        </button>
                        <button class="block centered alignCenter payButton bold noBorder white" v-on:click="goToDown"
                                :disabled="status === 'loading'" v-if="payStatus">
                            <i class="fa fa-spinner rotate" v-if="status === 'loading'" style="width:20px; height:20px"></i>
                            <!--                我已进群，立即下载-->
                            立即学习
                        </button>
                    </div>

                </div><!-- End 支付选项 -->

                <!-- 优惠券面板 -->
                <div class="generalPagePaddingH hiddenScrollbar"
                     v-show="currentContent == contents.coupon"
                     style="min-height: 300px; max-height: 250px; padding-top: 32px; overflow: auto;">
                    <div class="couponList">

                        <div class="couponItem flexLayout" :class="[!couponItem.isUse ?'disabled':'']"
                             style="padding-left: 16px; color: #FF3D38;"
                             v-for="couponItem in couponList" :key="couponItem.id"
                             @click="clickCoupon(couponItem)">
                            <div class="alignCenter" style="width: 47px; line-height: 33px; padding-top: 15px;">
                                <span class="f13 bold">￥</span>
                                <span class="bold" style="font-size: 32px;"
                                      v-if="couponItem.creditType == couponTypeEnum.FULL_REDUCTION.code ||
                                    couponItem.creditType == couponTypeEnum.STAND_BY.code"
                                >{{couponItem.creditAmount}}
                                </span>
                                <span class="bold" style="font-size: 32px;" v-if="couponItem.creditType === couponTypeEnum.DISCOUNT.code">
                                    {{new Number(couponItem.creditAmount * 10) + '折'}}
                                </span>
                            </div>
                            <div class="flexItem">
                                <div style="padding: 15px 10px 0 24px">

                                    <div class="font14r hiddenOverflow" style="line-height: 20px; height: 20px;">
                                        {{couponItem.couponName}}
                                    </div>

                                    <!--                                    <div class="font12r" style="margin-top: 4px; font-size: 8px;">-->
                                    <!--                                        <span v-show="couponItem.creditType == couponTypeEnum.FULL_REDUCTION.code">-->
                                    <!--                                            满减券 满{{couponItem.creditAmount}}元可用-->
                                    <!--                                        </span>-->
                                    <!--                                        <span v-show="couponItem.creditType == couponTypeEnum.STAND_BY.code">-->
                                    <!--                                            通用券-->
                                    <!--                                        </span>-->
                                    <!--                                        <span v-show="couponItem.creditType == couponTypeEnum.DISCOUNT.code">-->
                                    <!--                                            折扣券-->
                                    <!--                                        </span>-->
                                    <!--                                    </div>-->
                                    <div style="line-height: 11px; font-size: 8px;">
                                        有效期:
                                        <span v-if="couponItem.startTime">
                                            {{formatDateTime(couponItem.startTime)}}-
                                        </span>
                                        {{couponItem.useExpiryTime ? formatDateTime(couponItem.endTime) : ''}}
                                    </div>
                                </div>
                            </div>
                            <div class="alignC" style="width: 89px; padding-top: 24px;">

                                <template v-if="couponItem.isUse">
                                    <input type="checkbox" class="redCircleTickCheckbox" style="width: 20px; height: 20px;"
                                           :checked="couponItem === selectedCoupon"
                                           :disabled="!couponItem.isUse"/>
                                </template>

                                <span class="f11" v-else>优惠券不可用</span>
<!--                                <span class=" default" v-show="couponItem.isUse && couponItem != selectedCoupon">可选择</span>-->
<!--                                <span class="selected" v-show="couponItem.isUse && couponItem == selectedCoupon">已选择</span>-->
<!--                                <span class="disabled" v-show="!couponItem.isUse">不可选择</span>-->
                            </div>
                        </div><!-- End couponItem -->

                    </div>
                </div><!-- End 优惠券面板 -->





                <!-- 完善信息提示面板 -->
                <div class="fillInContactInformation"
                     v-show="currentContent === contents.fillInContactInformation">
                    <div class="warnArea f12 red" style="padding: 0 12px">
                        <i class="icon warnIcon marginR4 relative" style="top: 3px; width: 16px; height: 14px;"></i>
                        完善真实的个人信息，便于更好的学习。
                    </div>

                    <!-- form -->
                    <div class="generalPagePaddingH">
                        <div class="formRow clearfix" v-for="formFieldItem in formFields" :key="formFieldItem.field">
                            <div class="marginT24 darkgrey">
                                {{formFieldItem.field}}
                            </div>
                            <div class="marginT16 font18r">

                                <template v-if="formFieldItem.fieldType === 'PHONE'">
                                    <select class="grey20 font18r noBorder no_bg" style="margin-right: 30px;">
                                        <option>+86</option>
                                    </select>
                                    <input class="inputbox noBorder grey20 placeholderColorB8C2D6" type="text"
                                           :placeholder="formFieldItem.tips"
                                           :required="formFieldItem.required"
                                           v-model="contactInformationFormData[formFieldItem.field]"/>
                                </template>

                                <template v-else>
                                    <input class="inputbox noBorder block w100p grey20 placeholderColorB8C2D6" type="text"
                                           :placeholder="formFieldItem.tips"
                                           :required="formFieldItem.required"
                                           v-model="contactInformationFormData[formFieldItem.field]"/>
                                </template>

                            </div>
                        </div>
                    </div>

                    <div class="operationArea generalPagePaddingH" style="margin-top: 56px;">
                        <div class="clearfix">
                            <button class="button fl iconButton cancelButton" @click="cancel()"></button>
                            <button class="button fr iconButton saveButton" @click="saveContactInformation()"
                                    :disabled="disableSaveContactInformation()"></button>
                        </div>
                    </div>
                </div><!-- End 完善信息提示面板 -->





            </div>
        </div>
    </div>

</template>

<script>
// lib
import moment from 'moment';
import payComp from '../shixunApp/payComp';

// style
import '@/components/coupon/coupon.scss';

// data
import bizTypeEnum          from '@/data/bizTypeEnum';
import orderBizTypeEnum    from '@/data/orderBizTypeEnum';

// util
// import consoleHelper        from "@/util/consoleHelper";
import appHelper    from "@/util/appHelper";
import consoleApi from "@comp/platformApi/consoleApi";

const config = {
    apiConfig : {
        submitOrder : {
            url : "portal/v4/order/pay",
            method : 'post',
            idName : 'bizId',
            params : {
                orderBizType : 'THIRD_PARTY',
                coinType : 'RMB'
            }
        },
        getPayStatus : {
            url : "portal/order/pay/update_order_status",
            method : 'post'
        },
        couponList : {
            url : "portal/v2/coupon/getUseCouponsList",
            params : {
                orderBizType : orderBizTypeEnum.THIRD_PARTY.code
            }
        }
    }
};
export default {
    name: "goodsPayDialog",
    extends : payComp,
    data() {
        return {
            apiConfig : config.apiConfig,
            visible : false,
            contents : {
                pay : {
                    title : '确认支付'
                },
                coupon : {
                    title : '选择优惠券'
                },
                fillInContactInformation : {
                    title : '完善信息'
                }
            },
        }
    },
    methods : {
        open : function (){
            this.show();
        },
        close : function (){
            this.hide();
        },
        show : function (){
            this.visible = true;
        },
        hide : function (){
            this.visible = false;
        },
        formatDateTime : function (timestamp) {
            if (!timestamp)
            {
                return '';
            }
            return moment().format('YYYY.MM.DD');
        },
        selectCoupon() {
            if (this.couponList.length < 1)
            {
                appHelper.showHint('暂无优惠券可选');
            }
            else
            {
                this.currentContent = this.contents.coupon;
            }
        },
        fillInContactInformation() {
            // this.currentContent = this.contents.fillInContactInformation;
            consoleApi.log('fillInContactInformation');
            this.$emit('selectAddress');
        },
        disableSaveContactInformation() {
            // for (let i=0; i < this.formFields.length; i++)
            // {
            //     let tField = this.formFields[i];
            //     let tKey = tField.field;
            //     if (tField.required && this.contactInformationFormData[tKey] === '')
            //     {
            //         return true;
            //     }
            // }
            return false;
        }
    },
    mounted() {
        this.currentContent = this.contents.pay;
    }
}
</script>
<style lang="scss" scoped>
.red {
    color: hsla(2, 100%, 61%, 1);
}
.darkgrey {
    color: hsla(0, 0%, 17%, 1);
}
.grey {
    color: hsla(219, 16%, 60%, 1)
}
.lightGreyBg {
    background: #F9F9F9;
}
.arrowIcon {
    width: 14px;
    height: 14px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABI0lEQVRIie3VrUoEYRTG8RfEIJgEQYyCiK4zzHn+74QBk8ngBdiELQb3Buwmg9FiFTGIyaDBZhGTUYtabBbxY1cWxuA7sDdwFpR9buDHwzmHE8Io/z5FUWxKWhwWtg3UwAew4g7meb4s6T2hPUlr7qgkgNeEfprZhjtqZkuSnhP6LWnLHS2KYl7SA1BL6gI77qiZzUq6TU37kvaGgU4D1w1qZofuaKvVmgQuE1pLOnFHgXFJ5w0KHLujklbTAtWSnqqqmvDE1oFuavdmZtENM7M28JWavcQYzQ2LMXaAXmr2GGNccMMk7TYzA+6yLJvzxPaBPlCb2U1ZljOe2FGDAVdVVU15YqcDB37hvfqdAewshDDmhoXw+4CBezM7cIVG+VP5AUoCdS27VAqpAAAAAElFTkSuQmCC');
}
.default{
    display: inline-block;
    width: 53px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border: 1px solid #F92645;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 400;
    color: #F92645;
}

.selected{
    display: inline-block;
    width: 53px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background: #F92645;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 400;
    color: #FFFFFF;
}

//.disabled{
//    display: inline-block;
//    width: 53px;
//    height: 20px;
//    line-height: 20px;
//    text-align: center;
//    border: 1px solid #999999;
//    border-radius: 12px;
//    font-size: 10px;
//    font-weight: 400;
//    color: #999;
//}

.payDialog {
    .title {
        .inner {
            position: relative;
        }

        .icon {
            position: absolute;
            z-index: 1;
            left: 0;
            top: 4px;
        }
        .closeIcon {
            width: 14px;
            height: 14px;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC');
        }
    }
}
.payButton {
    font-size: 100%;
    display: block;
    width: 298px;
    margin: 0 auto;
    height: 2.625em;
    border-radius: 1.3125em;
    padding: 4px 0;
    line-height: 1.1em;

    background: linear-gradient(90deg, #FFA115 0%, #FFBF60 100%);
    // background: linear-gradient(168deg, #FF6434 0%, #FF3452 100%);
}
.fillInContactInformation {
    .red {
        color: hsla(2, 100%, 70%, 1);
    }
    .darkgrey {
        color: hsla(219, 9%, 39%, 1);
    }
    .grey {
        color: hsla(220, 27%, 78%, 1);
    }
    .warnArea {
        background: hsla(3, 100%, 96%, 1);
        height: 22px;
        line-height: 22px;

        .warnIcon {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAcCAYAAAAAwr0iAAACeklEQVRIiaVXPWtbMRR9g0tL8FrIFg+G9Ad0KfGgIVRXyruyCZ2yxLTgfkB/RQeH2JD8kxg6ZfLQ0XO7ZPCULhlNU0KG00Hye8+2+iQ5gre8+3V079XVUZYFFoRowKgDMA2R0xRMc7Bc2I/m7t8QRh1AiEbIX/SygenUBiREfnMYOn16cCPbMDSrOL4ByzGMJvSoBSGaEKKJHrVgNIHl2Oo4fUMzGNneLnhOAkx3ZWDqR9sy9StA7pCT2Cb4o3MwgRDNRPwZhGiCaeJ8PEaDgJHtYudGXaYG3vSnLotMhMrhGm5Z80kA6CcwLcC0gHn7uVZ3mQlDs3oAtna25oG0g+ljpTm/1Oracix7ov8/pUblqPmV/GABowYJ+nPvnABTZ7n7kLMsyzJ01bsyA/okyqbMQscnHFqhHEc5O5KHJQCl4gDIseuFbz4AP6xQU5Qzo18XAHJ6E2lDzmbqA2Dr36NWnDPZLjPAr6JsetRa9oEPwF8wIXboQKmXBQCtd6Ns7GkAWC42hXkB4EWUs8HgWQHgq3r+dACJJXA2f2DUfbR+oAS2CY/kYQKAWzD9jtavb0J55oSjeIf0E7n6Fa3PNHIlOPMJkwaRA7APQ/sJAGoGUeIoTl3BUbymFL6MtN6FoXMYOg8dQ9f94c25LLjrWF4FdnRduQ2v63Xld6dXfx1n2TohkRc1AG4qALx9Y/mFvIgmJIXhCiWTV75ygOkDmB7A9ACj3nuCNys7j6dkayBKUuqh2WDeAfPOxv9VGp9OSktHsl32RMGOR+iSxLHeK2j5sd5Dl6Q759XSbE/LV4DY05HyMEmi8XEg7AnpuIm5+TRjmjpZZ5un2T+CtLdIU2jkOgAAAABJRU5ErkJggg==');
        }
    }
    .formRow {
        border-bottom: solid 1px hsla(0, 0%, 94%, 1);
        padding-bottom: 12px;
    }
    .operationArea {
        .button {
            width: 163px;
            height: 42px;

            width: 43.4vw;
            height: 11.2vw;
        }
        .cancelButton {
            background-image: url('data:image/png;base64,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');
        }
        .saveButton {
            background-image: url('data:image/png;base64,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');
        }
        .button:disabled {
            opacity: .5;
        }
    }
}
.payTypeArea {
    .item {
        padding: 10px 16px 10px 11px;
    }
    .wechatPayIcon {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACMUlEQVRYhdWXIW/bUBDHD0S5/51jyaAgYNBgYB+hoGBgbIMDkTowaQMDhZVGJnXSwMikkUn7CK5kVX5nm3lSP8DAQMFAQUBAQEBBQUEH5rZJY6d22iTbSQd9/5/v3b17R0REfMShOo7U8ZkaLlfqjs/UccRHHBIREeccrkV4HmTCOYekKUdrF7/ylCPayN9PHQdtTLz0/xlARmr4JYYTNYzXBZDBYeAn/hbdMs+o7xleaYrjBwcQw4lksn1btM6QYKfMzEMA8CEV1Gsqfm0F9dT48F4AYvhBBXVai5fmJ/6WGk6XBJCJpPJoGWHPvL4YPqnjiZpM1DBsD+Dwsa0w5xyq4bsYztVwoYZvQRwEavy2NQDn5bAoDQl2/ITmqp+ISBLZVpN4Cv6457pPbjJC/bYA4zkRJy/VMPSTm27QvPtc3UzbjZBhUAVZ3htNAeTnXISCOmoY/U0tZ+Lwe+qbC8/4SxAHQd3x1LVlJYCkOK0K4pnsV9TKTLprAdLqbqgGMJxXtV8QB0FZYJdqGNalu+q71kXoOTytzILDQBJ+RwWhiTgRkRpeL3MPxE0FFlpBHZ2tl+Y3oWf87L76muFgkcZds2DsJ93Hy4pLKnt3xG80DceoqYdaKwiS8ucGsZuOY9lvKuxl2F105ksBaKovqKCepvxVDUNxHGmCD3DYVeM3ajhQ43iZB25DALwX1+yBsRqAFfo/ALDxxWTTq9nGllPD+PrRwzmHmq5xPU85uhL/A0F4aFxvEkSdAAAAAElFTkSuQmCC');
    }
    .orangeCircleCheckedIcon {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAACCklEQVRIib3WQWsTQRTA8Um/iNJ5WfXiQfBQsGkPJXjptQ1I+wly8wv00EsLvXjyE+zMRlEUSi9RUGKk0hxKsLf0IlqpUAy0JJLq38Nuut1mXXfJpgvvsjPMj3n7duYpleLBOLNY2cKVJkY6GDkNooMrTaxsYZzZNGv9G0EVMHoZK22MkDLaeLIEqpANq2nB6k8ZoKuxixWdDjMyj9EnY2BB6BNqMpeMufohVvrjYxfRx0o5HrM37mCkmyM2jC7uzdtRzC+Q/Qlgw/Tus6amLhWJrOQKPL8H2+Xou5qshLuzxcPcsO0y9I7h9wB2Fi+NFQ9BFRResZQbtrPoYwB/zq+AAl6xpHD1Zi5YfRkGZyHWqI7OsXpDBcfVeNibRyE2OIvHjIArTYWRo7GwRtX/XkOsXkmaf6Qw0hvd+i349g6+voWXM+mwX93/YWCkFw++nufi6Xbi0dZ6iPWOR3+DBDA+pe0nIXr6Jbpgaz0cS48FKU0qmriFD55Gd//qQYZvrt8rrN5InPTxsV/mEKYwKdVJ4erNdD9+owrn/RD7sQcv7mevaK9YCg7uFEdbveJX4vcP8OxudswGR5t/NenVzAtkBvVqeFusqSmstCaHyd5In4OddpjMBfwTO+3E3/qes5Bri2Glj+csJPc1NZm7tiYqmt5rahOjsK5g5XOGFLbxZCkzNALn2Or/BVEIP1mA4tchAAAAAElFTkSuQmCC');
    }
}

.modernCheckbox:before,
.redCircleTickCheckbox:before {
    display: inline-block;
    content: '';
    width: 100%;
    height: 100%;

    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAADJklEQVRYhdWZv0sjURDH3x9g4Z+Q3ivShJ1dd54LNoIWlhb3DxwK/gGJsJDyBA+Sf0EUcnBFvLvOxHjXGLXRJjYWKQI2CVgIXubNFW/fc42K2Zi48cFUC7sfZt5858cKMeK593JZ9iGv0K0oH2qEcE0It5FdKx9qCt0K+5C/93LZUb+T6DBAhiSUSEKbEDiRSWiThBIDZMYPFgSzhM4OIdzZD64usyqGrA6qrBpHzK0Wc6ejrdVi1TjSz4oh0+pyHPaO0NnhIJgdC1wfnc+ETtd8QIUF5uYJc6+XzJonrMJCDNTp9tFZexMcSSjaF26uM5+fJQcbtPMzps11C/pPQpgYjIO5GYXOD0JgWvBY7e2+HWzA1N4u04JnQPc4mJsZGtDCLS2yqh+OHc5C1g+ZlhYt5HDe86OwLi0yX15MDM7a5YWFfDXcOiGisE7Qc896Mgr3i4kTSUmXECZy54a6k1F2PytBhO6OzdZ3hjP2kN3u1wHvQcaI8FikZFQ7P7NizkGs4rCEkhXhtOBMqCMxZwmlB1mJamuq3jPWPNEVS0Jbe8/LZU1tTR3O3MWodrOXywr2IU8IrIph6mA2zMVQA/qQFwrdCiGwOqimDmYBD6o6zOhWhEKoEQKrv39SB7OAjaMIEGoi6oR1PzcFcNzrMbdaRm6uhdW/m5v0wYx1Ogbw9kMATneIFcLxVCeJlZnfv1IHs4BxmSEfCtMq1ORDIVbqVlIHM0arK1Gp8z49bhZGGSfHbYPNghBCkHTK09ZukXTKH6dhFUII8t1vuuXfSO/ubXwxybH9wtDkTsHQ5D4/NAkhBKOzRghMwTyreu394Oo1pmBeZ+5r+xqSEKY1uNOwe5o+wveH1cfkPKnqNQvXR9gfCk7fx7kZCxnMT255FIW1j7CfaHn0JNwmu8e1fjPZmiSsL3oTnTWT3VrMt5hPm8nBTpuswq3YAtPtvpoQQ0MGwWykk7EV8IpeAf+ssjpuMF/FVsBXLVbHDf2sGNraalfAPmyPbQX8GBQyJJ2yGmGJriS0STrlJxViUoe9XJZ8KCh0K9Fk+Pg3BOrfEORDwXYlI5z/oHHqLnwm0toAAAAASUVORK5CYII=');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.modernCheckbox:checked:before,
.redCircleTickCheckbox:checked:before {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAADGklEQVRYhc3Yv0sbYRgH8NfNVrAgxXZ06Y/pltzzPLkpWVMERcgfUCHgpgZsg4GilKJgcXJxDEiDqYOTg5DBxlUUQqlxilC6GEiNxin22+GsMbmLuTuTS194ltz73vvJe+/73vucUh4LRF6AeRZEm2D+BuYTiFxA5ALMJze/bYJ5FiIvvPbjDkX0HMzLYC6AGS6jAOZliDzrPExkEMyfQHTpAdYYRJcQ+QiRwU7h3oK59GCYNUoQmfQOU6oPRJ+7AGse0RUo1ecOFw73Q2Sr67g6cgvhcL9zIFHaN1wdmXaGY573HVeP9+1w4yD600PgNZjH7XGBwBMwn/UQ9y/OoGkDdqO38B/gzBD50Dx6T8H82zdAKARkMsD2NjA6ar1OVIZhDPVm9EIhIJ/HbSkWAcO4fxTBfOgLzjCAgwNYit0oMh+auGBwxDdcNmvF5XKt2wSDIwpE074AMxkr7ujIfOSt2ojMKDCnuo5Lpay4YhGIRNq1TSkwZ7uKW1214kolJziAOatA9KNruGTSHheNOr3HdwXmc0eVIxFgcbHVirNGPA7Uao24qytgctLNnyw7A46NAeWy2UmlAsRi99ePxYBqtRFXqwFTU26fwrmCk/xiY6Oxs2q1NTIatcclEl6mSUGBea9txbk561yyQ05MmHOsuayseJ3Hewpmati+st1qvIuMRMyto7msrXnFmYdYECUcN7BD1mrm4ikUrNfSae84EzitEAi8dtXIDmlXdncfhmM2X3U3OYi7vbAdcn/f/oTiLg7rpxmRJdc3aIVs9351Hgt1oGEMgajs+ibJZONmXCx2Btd8YH1QNhePm7Bczun71UnMW3MSTRsA868OdeA9RH7aJk1KKQVdfwPmWg+B19D1iC3uFulmX+x83J+435mPX3zHOf30oZRSCAQeg/mrj7gtGMYjx8BbqEgCRNddnXNECdewBiTzKIhOuzBqp20XhGNkONwPc5+sdABXga6/c/U90DFU04ZBtATmYw+wY4gsQdOGOw6zxer6KzDHQbQOoh0Q5WGmD+cgykNkB0TrEJkB80uv/fwFt5fiMLQtQskAAAAASUVORK5CYII=');
}
</style>
